import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  recurlyTokenDetail: null,
}

export const recurlyTokenSlice = createSlice({
  name: 'recurlyTokenData',
  initialState,
  reducers: {
    setRecurlyTokenData(state, action) {
      state.recurlyTokenDetail = action.payload
    },
    clearRecurlyTokenData(state) {
      state.recurlyTokenDetail = null
    },
  },
})

export const {setRecurlyTokenData, clearRecurlyTokenData} =
  recurlyTokenSlice.actions
export default recurlyTokenSlice.reducer
